<template>
    <section v-if="email && reportStore.reports[email].isReportFetch">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                        <div class="row match-height">
                            <div class="col-xl-12 col-lg-12">
                                <div class="row">
                                    <div class="col-12">
                                        <h4>APPEND CLIENT DOCUMENTS</h4>
                                        <div class="display-box mb-1">
                                            <div class="ml-2">
                                                <input
                                                    class="custom-control-input"
                                                    type="checkbox"
                                                    name="append_affidavit"
                                                    value="1"
                                                    tabindex="4"
                                                    v-model="checkbox"
                                                    id="append_affidavit"
    
                                                />
                                                <label class="custom-control-label" for="Make_the_recipient_the_sender" @click="changeCheckbox">
                                                    ID Theft Affidavit
                                                </label>
                                            </div>
    
                                        </div>
    
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-body">
                                        <editor
                                            id="lexisNexis"
                                            v-model="letters.lexisNexis"
                                            :api-key="settingStore.tinymce.api_key"
                                            :init="settingStore.tinymce.configuration"
                                        />
                                        <div class="d-flex justify-content-center my-1">
                                            <button class="btn btn-sm-block btn-primary" @click.once="submit" type="button" name="editorType" value="1">
                                                {{ localizationStore.translate("letter.left.submit.button.text") }}
                                            </button>
                                            <button
                                                class="btn btn-outline-primary ml-1"
                                                @click="spin"
                                                type="button"
                                            >
                                                {{ localizationStore.translate("spin.letter.button.text") }}
                                            </button>
                                        </div>
                                        <div class="row">
                                            <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRef' />
                                        </div>
                                        <div ref="lexisNexis" hidden>
                                            <lexisnexis-bankruptcy-validation-letter v-if="$route.params.letter == 49" :creditBureau="getCreditBureau('LexisNexis Risk Solutions')" />
                                            <lexisnexis-bankruptcy-response-letter v-if="$route.params.letter == 50" :creditBureau="getCreditBureau('LexisNexis Risk Solutions')" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
  import { ref, reactive, computed } from 'vue'
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  import { useReportStore } from '../../stores/ReportStore.js'
  import { useUserStore } from '../../stores/UserStore.js'
  import { useSettingStore } from '../../stores/SettingStore.js'
  import moment from 'moment';
  import Editor from '@tinymce/tinymce-vue'
  export default {
    props: {
        csrf: {
            type: String
        },
        propCreditBureaus: {
            type: [Array, Object]
        },
        userInfo: {
            type: [Array, Object]
        },
    },
    components: {
        'editor': Editor
    },
    setup(props) {
        return {
            creditBureaus: props.propCreditBureaus,
            editorRef: ref(null),
            date: ref(moment().format('LL')),
            localizationStore: useLocalizationStore(),
            reportStore: useReportStore(),
            userStore: useUserStore(),
            email: ref(null),
            letters: reactive({
                lexisNexis: null
            }),
            settingStore: useSettingStore(),
            checkbox:ref(false),
        };
    },
    watch: {
        'userStore.user'(value) {
            if (value != null) {
                this.email = value.email;
                if (!this.reportStore.reports[this.email]) {
                    this.reportStore.getReport();
                }
            }
        },
    },
    created() {        
    },
    mounted() {
    },
    updated() {
        this.$nextTick().then(() => {
            this.letters.lexisNexis = this.$refs.lexisNexis.innerHTML;
        });
    },
    computed: {
    },
    methods: {
        goBack: function () {
            if (this.$route.params.client) {
                const route = this.$router.resolve({ 
                    name: 'report',
                    params: { client: this.$route.params.client }
                });
                window.location.href = route.href;
                return;
            }
            const route = this.$router.resolve({ 
                name: 'disputes-report'
            });
            window.location.href = route.href;
        },
        getCreditBureau(name) {
            return _.find(this.creditBureaus, function(creditBureau) { return creditBureau.name == name; });
        },
        submit() {
            let params = { letter: this.$route.params.letter };
            if (this.$route.params.client) {
                params.client = this.$route.params.client
            }
            if (this.$route.params.team) {
                params.team = this.$route.params.team
            }
            const route = this.$router.resolve({ 
                name: 'create-letter',
                params: params
            }),
            $this = this,
            payload = {
                multipe_letters: true,
                letters: []
            };
            _.forEach($this.creditBureaus, function(creditBureau) {
                payload.letters.push({
                    letter_id: $this.$route.params.letter,
                    credit_bureau_name: creditBureau.name,
                    letter_preview: tinymce.get("lexisNexis").getContent(),
                    append_affidavit : $this.checkbox,
                });
            });
            axios.post(route.href, payload)
            .then(function (response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                toastr.success(response.data.message, 'Success!');
                setTimeout(() => {
                    window.location.href = response.data.data.url;
                }, 3000)
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        spin() {
            this.$refs.spinner.spin(tinymce.get("lexisNexis"))
        },
        changeCheckbox(){
            this.checkbox = !this.checkbox
        }
    }
  };
</script>